import React, { useState } from 'react';

import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { CloseCircle, ForwardItem } from 'iconsax-reactjs';

import { ButtonGroupButtonStyled } from '../../styles';

const ProgramRegister = React.memo(() => {
  const [isShow, setShow] = useState(false);
  // const { user } = useContext(UserContext);
  //
  // const paymentUrl = useMemo(() => {
  //   const url = process.env.REACT_APP_PAYMENT_URL;
  //
  //   if (!url || !user) {
  //     return null;
  //   }
  //
  //   return `${url}?prefilled_email=${user!.email}`;
  // }, [user]);

  return (
    <>
      <ButtonGroupButtonStyled
        variant="contained"
        color="primary"
        endIcon={<ForwardItem size={16} />}
        onClick={() => setShow(true)}
      >
        Je m&apos;inscris au programme
      </ButtonGroupButtonStyled>

      <Dialog open={isShow}>
        <DialogTitle>S`INSCRIRE AU PROGRAMME</DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setShow(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseCircle />
        </IconButton>

        <DialogContent>
          <Typography variant="md">
            Nous sommes ravis de vous compter très bientôt au sein du programme Mon Coach Mobilité
            par KINT, merci pour votre confiance.
          </Typography>
        </DialogContent>

        {/* <DialogActions> */}
        {/*  {paymentUrl && ( */}
        {/*    <Button */}
        {/*      variant="primary" */}
        {/*      onClick={() => { */}
        {/*        window.location.href = paymentUrl; */}
        {/*      }} */}
        {/*    > */}
        {/*      Procéder au paiement */}
        {/*    </Button> */}
        {/*  )} */}
        {/* </DialogActions> */}
      </Dialog>
    </>
  );
});

export default ProgramRegister;
